import cn from "classnames";
import Badge from "app/components/shared/Badge";
import LinkButton, { Style } from "./LinkButton";
import mark from "app/images/mark.svg";

interface Props {
  id?: string;
}

export default function Header({ id = undefined }: Props) {
  return (
    <header
      className={cn(
        ["absolute", "w-full", "z-10"],
        ["flex", "flex-wrap", "items-center", "gap-2", "justify-between"],
        ["p-2", "min-h-12"],
        ["bg-white", "border-b", "border-slate-200"],
      )}
    >
      <div className="flex items-center gap-x-1">
        <LinkButton
          buttonStyle={Style.Tertiary}
          className="px-0.5"
          href={id ? `/pipelines/templates/${id}` : "/"}
        >
          <img alt="Buildkite logo" className="mx-auto w-8" src={mark} />
        </LinkButton>
        <h1 className="font-medium">
          Pipeline Playground
          <Badge outline={true}>Beta</Badge>
        </h1>
      </div>
      <div>
        <LinkButton buttonStyle={Style.Primary} href="#" className="">
          Add to my repo
        </LinkButton>
      </div>
    </header>
  );
}
